/**
 * Smooth scroll for in-page anchor links (#id).
 * Intercepts clicks on same-page hash links and scrolls smoothly with offset (see theme.css scroll-margin-top).
 */
document.addEventListener('click', (e) => {
  const link = e.target.closest('a[href^="#"]');
  if (!link || !link.hash || link.hash === '#') return;

  const id = link.hash.slice(1);
  if (!id) return;

  const target = document.getElementById(id);
  if (!target) return;

  // Same page: hash-only href, or pathname matches, or href equals hash
  const href = link.getAttribute('href') || '';
  const isSamePage = href === link.hash ||
    href === '#' + id ||
    link.pathname === window.location.pathname ||
    (href.startsWith('#') && !href.includes('//'));
  if (!isSamePage) return;

  e.preventDefault();
  e.stopPropagation();

  target.scrollIntoView({ behavior: 'smooth', block: 'start' });

  if (history.replaceState) {
    history.replaceState(null, '', link.hash);
  } else {
    window.location.hash = link.hash;
  }
}, { passive: false, capture: true });
